

import { useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import styles from "./auth.module.scss";
import FormInput from "./formInput";

type FormData = {
    email: string
    name: string
    password: string
    confirmPassword: string
    terms: boolean
}

export default function Component({ setForm }: { setForm: (form: string) => void }) {
    const { register, handleSubmit, formState: { errors, isSubmitting } } = useForm<FormData>()
    const [showPassword, setShowPassword] = useState(false)

    const onSubmit = handleSubmit(async data => {
        return fetch("/api/auth/signup", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data),
        })
            .then(r => r.json())
            .then(r => {
                if (!r.resp) throw new Error(r.msg)

                toast.success("Η εγγραφή σας ολοκληρώθηκε. Σας έχει αποσταλεί email επιβεβαίωσης.")
                setForm("")
            }).catch(e => toast.error(e.message))
    })

    return (
        <div className={styles.signIn}>
            <form onSubmit={onSubmit}>
                <FormInput
                    type="email"
                    placeholder="Email"
                    className={styles.inputContainerCustomStyle}
                    error={errors.email?.message}
                    {...register("email", { required: "Αυτό το πεδίο είναι υποχρεωτικό" })}
                />

                <FormInput
                    type="text"
                    placeholder="Όνομα"
                    className={styles.inputContainerCustomStyle}
                    error={errors.name?.message}
                    {...register("name", {
                        required: "Αυτό το πεδίο είναι υποχρεωτικό",
                        minLength: {
                            value: 3,
                            message: "Το όνομα πρέπει να είναι τουλάχιστον 3 χαρακτήρες",
                        },
                        maxLength: {
                            value: 30,
                            message: "Το όνομα πρέπει να είναι το πολύ 30 χαρακτήρες",
                        }
                    })}
                />

                <FormInput
                    type={showPassword ? "text" : "password"}
                    placeholder="Κωδικός"
                    className={styles.inputContainerCustomStyle}
                    error={errors.password?.message}
                    {...register("password", {
                        required: "Αυτό το πεδίο είναι υποχρεωτικό",
                        minLength: { value: 8, message: "Ο κωδικός πρέπει να είναι τουλάχιστον 8 χαρακτήρες" },
                    })}
                    addon={(
                        <button className={styles.showPass} type="button" onClick={() => setShowPassword(!showPassword)}>
                            {showPassword ? <i className="svgIcon"
                            ><svg><use xlinkHref="#IconEyeSlash"></use></svg></i> : <i className="svgIcon"
                            ><svg><use xlinkHref="#IconEye"></use></svg></i>}
                        </button>
                    )}
                />

                <FormInput
                    type="password"
                    placeholder="Επιβεβαίωση κωδικού"
                    className={styles.inputContainerCustomStyle}
                    error={errors.confirmPassword?.message}
                    {...register("confirmPassword", {
                        validate: (value, form) => value === form.password || "Οι κωδικοί δεν ταιριάζουν",
                    })}
                />

                <div className={styles.accept}>
                    <input type="checkbox" id="terms" {...register("terms", { required: "Πρέπει να αποδεχτείτε τους όρους χρήσης" })} />
                    <label htmlFor="terms">Αποδέχομαι τους<a href="/oroi-xrhshs" target="_blank">όρους χρήσης</a>του Newsbeast</label>
                </div>

                <button className="cmnBtn" disabled={isSubmitting}>Εγγραφή</button>
            </form>

            <div className={styles.actions}>
                <div className={styles.login}>Ήδη μέλος;<button onClick={() => setForm("signIn")}>Συνδεθείτε τώρα!</button></div>

                <div className={styles.contactUs}>
                    <a href="/contact" onClick={() => setForm("")}>Επικοινωνήστε μαζί μας</a>
                    <span> για σχόλια, παρατηρήσεις &amp; τεχνικά προβλήματα σχετικά με τον λογαριασμό σας.</span>
                </div>
            </div>
        </div>
    )
}